import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useLazyCouponsViewQuery,
  useCouponsEditMutation,
  useCouponsAddMutation,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const Coupon = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const types = location?.state?.type;

  const [roles, setRole] = useState("");
  const [name, setName] = useState("");
  const [conPassword, setConPassword] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [rolesErr, setRoleErr] = useState(false);
  const [nameErr, setNameErr] = useState(false);
  const [conPasswordErr, setConPasswordErr] = useState(false);
  const [passwordErr, setPasswordErr] = useState(false);
  const [usernameErr, setUserNameErr] = useState(false);
  const [emailErr, setEmailErr] = useState(false);
  const [btn, setBtn] = useState(false);

  // RTK QUERY
  const [addApi] = useCouponsAddMutation();
  const [editApi] = useCouponsEditMutation();
  const [viewApi] = useLazyCouponsViewQuery();

  const submitHandler = () => {
    if (
      name?.length == 0 ||
      username?.length == 0 ||
      email?.length == 0 ||
      roles?.length == 0
    ) {
      setRoleErr(true);
      setNameErr(true);
      setUserNameErr(true);
      setEmailErr(true);
    } else {
      let formdata = new FormData();
      formdata.append("type", roles);
      formdata.append("coupon_code", name);
      formdata.append("amount", username);
      formdata.append("validity", email);

      if (types == "edit") {
        dispatch(saveLoader(true));
        setBtn(true);
        editApi({ id: location?.state?.data?.id, payload: formdata })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate("/coupon-list");
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err");
          });
      } else {
        dispatch(saveLoader(true));
        setBtn(true);
        addApi(formdata)
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status === "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate("/coupon-list");
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.error("Error", err);
          });
      }
    }
  };

  const getView = () => {
    dispatch(saveLoader(true));
    viewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        if (res?.status == "success" || res?.data?.status == "success") {
          let coupon = res?.coupon;

          if (coupon?.coupon_code) {
            setName(coupon?.coupon_code);
          }

          if (coupon?.type) {
            setRole(coupon?.type);
          }

          if (coupon?.amount) {
            setUserName(coupon?.amount);
          }

          if (coupon?.validity) {
            setEmail(coupon?.validity);
          }
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err");
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader
        type={
          types == "view"
            ? "view-coupon"
            : types == "edit"
            ? "edit-coupon"
            : "add-coupon"
        }
      />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Coupon code
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                  disabled={types == "view" ? true : false}
                />
              </div>
              {name?.length == 0 && nameErr && (
                <p className="err">Enter Coupon code</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Type
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setRole(e.target.value)}
                  value={roles}
                >
                  <option value={""}>Select Type</option>
                  <option value={6}>Influencer Coupon</option>
                  <option value={7}>Exciting offers</option>
                </select>
              </div>
              {roles?.length == 0 && rolesErr && (
                <p className="err">Select Type</p>
              )}
            </div>
            {roles == 6 || roles == 7 ? (
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                    Validity
                  </label>
                  <input
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    disabled={types == "view" ? true : false}
                  />
                </div>
                {email?.length == 0 && emailErr && (
                  <p className="err">Enter Validity</p>
                )}
              </div>
            ) : (
              ""
            )}

            {roles == 6 && (
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                    Amount
                  </label>
                  <input
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    onChange={(e) => setUserName(e.target.value)}
                    value={username}
                    disabled={types == "view" ? true : false}
                  />
                </div>
                {username?.length == 0 && usernameErr && (
                  <p className="err">Enter Amount</p>
                )}
              </div>
            )}

            {roles == 7 && (
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                    Percentage
                  </label>
                  <input
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    onChange={(e) => setUserName(e.target.value)}
                    value={username}
                    disabled={types == "view" ? true : false}
                  />
                </div>
                {username?.length == 0 && usernameErr && (
                  <p className="err">Enter Percentage</p>
                )}
              </div>
            )}
          </Row>
          <Row>
            <div className="col-md-12 text-center mt-4 mb-4">
              <button
                className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                onClick={() => submitHandler()}
                disabled={btn}
              >
                Save
              </button>
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Coupon;
